import type { ReactNode } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../__generated__'
import { resolveIsBrandingHidden } from '../../utils/resolveIsBrandingHidden'
import { AppWrapper } from '../InstitutionLayout/AppWrapper'
import { SurveyHeader } from './SurveyHeader'

const fragments = {
  SurveyLayout_survey: graphql(`
    fragment SurveyLayout_survey on PublicSurvey {
      id
      institution {
        id
        config {
          id
          isBrandingHidden
        }
        partner {
          id
          config {
            id
            isBrandingHidden
          }
        }
      }
      ...SurveyHeader_survey
    }
  `),
}

type SurveyLayoutProps = {
  children?: ReactNode
  survey: FragmentType<typeof fragments.SurveyLayout_survey>
}

export const SurveyLayout = ({ children, survey: _survey }: SurveyLayoutProps) => {
  const survey = getFragmentData(fragments.SurveyLayout_survey, _survey)

  const isBrandingHidden = resolveIsBrandingHidden(survey.institution)

  return (
    <AppWrapper
      variant='simple'
      headerComponent={<SurveyHeader survey={survey} isHiddenBackButton />}
      isBrandingHidden={isBrandingHidden}
      hideSecuredBanner
    >
      {children}
    </AppWrapper>
  )
}
